import React from 'react';
import Moment from 'moment';
import IconButton from '@mui/material/IconButton';
import AddTurfToCrewDropZone from './AddTurfToCrewDropZone';
import { DoorCrewCardProvider } from './DoorCrewCardContext';
import SeatList from './SeatList';
import { DoorCrew, ShiftMeta, Canvasser, TurfCode, Turf } from './types';

interface DoorCrewCardProps {
  crew: DoorCrew;
  shiftData: ShiftMeta[];
  canvassers: Canvasser[];
  turfCodes: TurfCode[];
  onDeleteCrew: () => void;
  onCanvasserUpdate: () => void;
  onDropoffRequest: () => void;
  onOpenTurfNoteModal: (turf: Turf & { crew_id: number }) => void;
}

function getShiftLabel(shiftData: ShiftMeta[], shiftId: number): string | null {
  const shift = shiftData.find((d) => d.id == shiftId);
  if (!shift) return null;
  return (
    Moment(`${shift.shift_date} ${shift.start_time}`).format('LT') +
    ' - ' +
    Moment(`${shift.shift_date} ${shift.end_time}`).format('LT')
  );
}

export default function DoorCrewCard({
  crew,
  shiftData,
  canvassers,
  turfCodes,
  onDeleteCrew,
  onCanvasserUpdate,
  onDropoffRequest,
  onOpenTurfNoteModal,
}: DoorCrewCardProps) {
  const shiftLabel = getShiftLabel(shiftData, crew.shift);
  const borderColor = crew.color || '#62b03b';

  const handleOpenNoteModal = (turf: Turf, crewId: number) => {
    onOpenTurfNoteModal({ ...turf, crew_id: crewId });
  };

  return (
    <div className="assign-crew-card door-crew-card">
      <div className="crew-card-top-icons">
        <IconButton
          size="small"
          onClick={onDeleteCrew}
          title="Delete crew"
          className="remove-crew-icon"
        >
          <i className="far fa-times-circle" />
        </IconButton>
      </div>

      <div className="crew-title" style={{ color: borderColor }}>
        Crew {crew.id}
        {shiftLabel ? ` · ${shiftLabel}` : null}
      </div>

      <DoorCrewCardProvider
        crew={crew}
        canvassers={canvassers}
        turfCodes={turfCodes}
        onCanvasserUpdate={onCanvasserUpdate}
        onDeleteCrew={onDeleteCrew}
        onOpenNoteModal={handleOpenNoteModal}
      >
        <SeatList color={borderColor} />
        <AddTurfToCrewDropZone crewId={crew.id} />
      </DoorCrewCardProvider>

      <div className="crew-card-bottom-buttons">
        <div className="button button-clear" onClick={onDropoffRequest}>
          Assign Dropoff Locations
        </div>
      </div>
    </div>
  );
}
